const en = {
    language: 'English',

    menu: {
        home: 'Home',
        service: 'Product & Service',
        product: 'Products',
        products: 'Tool Kit',
        solution: ' Solutions',
        message: 'News',
        developer: 'Developer',
        browser: 'Explorer',
        aboutUs: 'About Us',
        lang: '中/EN'
    },

    home: {
        slider1: {
            title: 'HWelltech',
            description: 'Focus on blockchain technology research, development and product innovation '
        },
        slider2: {
            title: 'HWelltech',
            description: 'Provide comprehensive blockchain solution'
        },
        slider3: {
            title: 'HWChain',
            description: 'Provide efficient and stable underlying blockchain platform for different applications '
        },

        part2: {
            head: 'HWChain',
            desc: 'HWChain provides professional and rich blockchain functions',
            title1: 'Asset Digitization',
            text1: 'Support the issuance of NFToken to digitize different types of assets.',
            title2: 'Data To Blockchain',
            text2: 'Support text and file storage on HWChain.',
            title3: 'Smart Contract',
            text3: 'It is easy for contract writing,deployment and execution.',
            title4: 'Cross-chain Service',
            text4: 'Realize the interchange between HWChain and other blockchains.',

        },
        part3: {
            head: 'Service Content',
            desc: 'Provide a full range of services from solution consulting to application building',
            title1: 'Solutions',
            description1: 'Provide enterprises with a complete set of industry solutions from solution consulting to application construction.',
            text11: 'Integration solution consulting',
            text12: 'Platform service construction',
            text13: 'Application design implementation',
            text14: 'Smart contract writing and deployment',
            text15: 'Service operation and maintenance',
            title2: 'Blockchain Service',
            description2: 'Provide low-threshold, low-cost blockchain services for users with up-chain requirements.',
            text21: 'Blockchain data deposit service',
            text22: 'On-chain data inquire and verification service',
            text23: 'Digital asset management service',
            text24: 'Smart contract service',
            title3: 'Developer Support',
            description3: 'Provide developers with infrastructure and documentation support to develop blockchain applications.',
            text31: 'Developer infrastructure',
            text32: 'Development documentation support',
        },
        part4: {
            head: 'Solutions',
            desc: 'We have rich experience in realizing applications for various industry blockchains',
            title1: 'Supply Chain Finance',
            text1: "Serve supply chain finance by blcokchain's qualities of transparent,non-tamperable and circulation.",
            title2: 'Tracing',
            text2: 'To realize counterfeiting traceability by blockchain qualities of transparent, traceability and non-tamperable.',
            title3: 'Internet Of Things',
            text3: 'Realize the data up-chain of IoT devices by using the qualities of HWChain height-concurrency and file-uplink.',
            title4: 'Medical',
            text4: 'Help medical industry blockchain application by  HWChain with qualities of high concurrency, fast confirmation, and good stability.',
            a: 'Solutions',
        },
        part5: {
            tit: 'Partner',

        },
    },

    service: {

        part1: {

            tit: 'HWChain',
            text: 'Self-developed advanced controllable blockchain platform ',

        },
        part2: {
            tit: 'Technical Features',
            text: 'Blockchain platform with superior performance',
            tit1: 'High Performance',
            text1: 'The performance of the HCP consensus reaches 5000+TPS.',
            tit2: 'Safety',
            text2: 'Multiple security mechanisms ensure asset and txn security.',
            tit3: 'Stable',
            text3: 'The monitoring system ensure the stability of HWChain service.',
            tit4: 'Scalable',
            text4: 'Functions such as encryption algorithm can be modularized.',

        },
        part3: {
            tit: 'Core Underlying Platform',
            text: 'Self-developed advanced controllable blockchain bottom platform',
            tit1: 'Consensus Mechanism',
            text1: 'Self-developed HCP censensus algorithms on base of PBFT, it turns out with high performance.',
            tit2: 'Encryption Algorithm',
            text2: 'Support international standard / national secret SM2 standard elliptic curve encryption algorithm.',
            tit3: 'Smart Contract',
            text3: 'LUA virtual machine is efficient and easy to use, its contract execution log can be traced.',
            tit4: 'Data load To Blockchain',
            text4: 'According to the size of the data, there are two data-winding schemes for text and IPFS.',
            tit5: 'Asset Digitization',
            text5: 'To realize NFToken non-homogeneous digital assets by ERC721 standard.',
            tit6: 'Bulk Transfer',
            text6: 'Supports atomic-level single-account bulk transfer.',
            tit7: 'Decentralized Transaction',
            text7: 'Support the decentralized matching transaction among assets on HWChain.',
            tit8: 'Cross-chain Service',
            text8: 'Realize the efficient exchange among HWChain and other blockchains.',
        },
        part4: {
            tit: 'Empower Service Platform',
            text: 'Provide easy access to comprehensive blockchain service platform',
            tit1: 'API',
            text1: 'Rich API can easily interface with various application systems and then offer blockchain basic services.',
            tit2: 'Asset Digital Platform',
            text2: 'Conveniently distribute Token and NFToken for applications with asset digital requirements. ',
            tit3: 'Blockchain Explorer',
            text3: 'The HWChain account information inquiry tool provides a platform for transaction verification for applications on the HWChain.',
            tit4: 'Operation & Maintenance Platform',
            text4: 'Real-time monitoring of operation status of HWChain node, ensures HWChain provides stable service.',
        },
        part5: {
            tit: 'Node Running Status',
            l11: 'Service online time：',
            l12: 'Running Status',
            l21: 'Service running',
            l22: 'Nodes',
            l23: 'Block height',
            l24: 'Total txAmount',
            day: 'day',
        }
    },

    solution: {

        head: {
            tit: 'Blockchain Solution Provider ',
            text: 'Provide solution consulting to application and build a complete set of industry solutions ',
        },
        center: {
            show1: 'Asset Digitalization',
            show2: 'Tracing',
            show3: 'Data Sharing',
            show4: 'Entrusted Certificates',
            tit1: 'Solution',
            tit2: 'Application Case',
            partner: 'Partner',
            time: 'Launch Time',
            tit3: 'Production Information',
            tit4: 'Production Interface',
        },
        part1: {
            text1: 'Assets being digitized can be traded in split,reducing the threshold and complexity of asset trading,  improving assets liquidity and trading efficiency.The process of asset trading is also the process of asset circulating and certifying records in the chain. Open, transparent circulation records and trustable certificate  records in chain can effectively avoid manipulation and cheat in trading process.',
            label: 'IoT Expo Bridge',
            partner: 'World IoT Expo of 2018',
            time: 'Sept.2018',
            text2: 'Developed for 2018 World IoT Expo, IoT Expo Bridge is a tailor-made program recording the interaction between exhibitors and visitors, and delivering added value by blockchain technology. The program facilitates the business card exchange, gift redeem and conference promotion. With the blockchain, exhibitors can obtain the business card information of visitors and issue gifts in an open and transparent way. Visitors get bonus points and redeem gifts by exchanging business cards. The interaction between exhibitors and visitors is completely transparent, which avoids prize manipulation.',
        },
        part2: {
            text1: 'Based on non-tampered and traceable features of blockchain, commodities information are recorded on chain from raw materials to finished products, from production to distribution. One item with one code, facilitizes the visible traceability of the whole chain and the source of the problem commodities, so as to realizes the accountability with evidence. In combination with the IoT, information can also be automatically recorded on chain, realizes less energy consuming and more credibility.',
            label: 'Agricultural Products Traceability',
            partner: 'ChengXin Blockchain Technology (Yunnan) Co., Ltd',
            time: 'June,2019',
            text2: 'ChengXin Agricultural Poducts Traceability Platform  aiming to establish a high-quality system to empower local high-quality agricultural product brands. With features of block chain technology(transparent and anti-tamper), and IoT technology, this platform records cultivation and breeding  information, such as seedling fertilizer, environmental monitoring, production diary, picking and selection, packaging and logistics, sale channels, origin tracing, etc.on chain , so as to improve the credibility of enterprise and products, reduce the cost and difficulty of supervision.',
        },
        part3: {
            text1: 'By blockchain features of traceability and anti-tamper, the data access authorization on chain can be realized, which can effectively solve the problems of data ownership, data sharing control, data anti-tamper and data supervision in the process of data sharing cross multiple agencies and departments. Building of blockchain trusted data exchange greatly improves the efficiency of data security and the data exchange.',
            label: 'Government Data Sharing Platform',
            partner: 'Science and Information Bureau of Wuxi Xinwu District',
            time: 'Nov.2017',
            text2: 'The independent data management among the government departments in Xinwu District of Wuxi City weaken the service ability of the government departments. Also there are snags across law, supervision, privacy and security for  sharing of government data. Facilitated by blockchain technology to achieve data exchange between departments, each department is not only the provider of data, but also the demander of data. Achieved data access authorization with blockchain, government can effectively realize  identification of data ownership,supervision of data rights, ensurance of data validity and security, thus greatly improve the utilization and value of government data.',
        },
        part4: {
            text1: 'With the features of anti-tamper and multi-concensus, blockchain can be used in the field of digital certificates. The information stored by multi-parties is secure, tamper-proof, permanent and reliable. It can be regarded as direct evidence without the need of third party certification. HENGWEI blockchain integrated with IPFs realizes the file on-chain and expands the types of certificates. The IPFs hash of files is recorded on the HENGWEI-chain and cannot be tampered with.',
            label: 'Big Data Platform of Intelligent Factory',
            partner: 'Shanghai XinZengDing Data Technology Co., Ltd',
            time: 'Aug.2018',
            text2: 'XinZengDing collects independent data by IoT equipment in factory. Based on rich data and artificial intelligence technology, it realizes data calculation, data modeling and  AI industry analysis. With blockchain technology, it stored core data calculation results by multi-party concensus. With visualization technology and tools for multi-dimensional data analysis, drilling, tracing, reasoning and deduction,it realizes comprehensive and real-time display of factory operation and provides accurate and trusted judgement for supervisor and credit agencies.',
        },


    },



    message: {
        part1: {
            tit: 'News and information',
            text: 'Get the latest blockchain industry news'
        },
        part2: {
            time: 'Published:'
        }
    },



    aboutUs: {
        part1: {
            span11: 'Persevere',
            span12: '',
            span21: 'Human effort can achieve anything',
            span22: '',
        },
        part2: {
            tit: 'Company Profile',
            text1: "Jiangsu Hengwell Information Technology Co., Ltd. (hereinafter referred to as Hwelltech ) is an enterprise founded by overseas returned talents, which focuses on the research, development and application of the bottom layer of the blockchain. The company was founded in 2015. Keep with frontier blockchain technology, Hwelltech has its own core and underlying technologies of blockchain and blockchain application subsidiaries, which are planned to cover a complete blockchain ecosystem, including blockchain underlying technology research & development and application services. Hwelltech provides government and corporations with smart city application, public service application, IoT application . Hwelltech's own blockchain intellectual property  and Co-Chain technology is in line with international top level in terms of scalability, TPS, response delay and other technical indicators. Its realization of smart contract and Atomicity Cross-Chain is ahead of domestic competitors. At present, Hwelltech is tackling the most cutting-edge IPFs storage and hierarchical fragmentation in global blockchain research and development, and continues standing the leading position in the technology.",
            text21: 'With the announcement by the State Internet Information Office for the second batch of domestic blockchain service filings, "HWChain" successfully filed with No.',
            text22: '(snxb No. 32021419481366870014)',
            text23: '.',
            text3: "Catering to globalization of blockchain, Hwelltech positioned as an global company with independent R & D technology since its establishment, and it has distributed and expanded industry resources in Canada and Singapore. By the first half of 2019, the company has 5 overseas operating institutions and partners, and  also established strategic cooperation with global Chip IP giant company ARM and Zhangjiang High-Technology Park, Johnson China, Geely Auto, New Hope Group, etc. ",
        },
        part3: {
            tit: 'Company Honor',
        },
        part4: {
            tit: 'Contact Us',
            add: '19th Floor, Building D, Cygnus, 111 Linghu Avenue, Xinwu District, Wuxi City',
            email1: 'Technical Cooperation ',
            email2: 'Business Negotiation',
            email3: 'Strategic Deployment ',
            ewm: 'Official Account',
        },
        part6: {
            tit: 'Hwelltech',
            text1: "Relying on Wuxi's strong IoT industry and the successful experience of the world IoT Expo held over years, Hwelltech established a blockchain industry application center in Wuxi. At present, the application of blockchain has  extended to many fields such as IoT, intelligence manufacturing, supply chain management, digital asset trading, etc., which will bring opportunities for new generation of information technology as AI,IoT,cloud computing, big data, mobile Internet, etc., and trigger a new round of technological innovation and industrial upgrade.",
            text2: ' With solid blockchain technology, Hwelltech has accumulated more than 30 overall solutions in nine fields, including medical treatment, agriculture,livelihood, data sharing, fintech etc. Many schemes are the breakthrough innovations in the industry: Cooperating with ARM company to combine blockchain and IoT chips firstly around the world, Its data sharing product of "data governance gateway on blockchain" has become the first domestic blockchain platform applied to public data sharing . "',
        },
        part5: {
            tit: 'Hwelltech Milestones',
            year15: '2015',
            year16: '2016',
            year17: '2017',
            year18: '2018',
            year19: '2019',
            y17: {
                data1: '1/5/2017  ',
                event1: 'The setup of IoT+Blockchain Lab, and the release of Action Plan.',
                data2: '1/8/2017 ',
                event2: 'The release of Bluebook of Innovation Integration of Blockchain and IoT of China.',
                data3: '1/12/2017',
                event3: 'Passed the Blockchain Technology Assessment by China Electronics Standardization Institution.',
                data4: '12/2017 ',
                event4: 'Bluebook of Innovation Integration of Blockchain and IoT is listed in Top 10 most influential events of "2017 Wuxi Software and Information Service Industry (Enterprise)".',
            },
            y18: {
                data1: '1/6/2018',
                event1: 'Initiated the Establishment of China Canada IoT and Blockchain Industry Development Research Institute (Wuxi Branch).',
                data2: '1/8/2018 ',
                event2: 'Officially Establishment of China Canada IoT and Blockchain Industry Development Research Institute (Wuxi Branch).',
                data3: '1/9/2018',
                event3: 'Host the Conference of Block Chain and IoT Integration Development Summit of 2018 World IoT Expo.',
            },
            y19: {
                data1: '1/4/2019',
                event1: 'Preparing for the China First Local Standards for Integration of IoT and Blockchain.',
                data2: '1/8/2019',
                event2: 'Become Member of Board of Directors of China Blockchain Technology and Industry Development Forum.',
                data3: '18/10/2019',
                event3: 'HWChain passed Blockchain Information Services Approval of China',
            }
        }
    },
    hwtool: {
        part1: {
            tit1: 'Hwelltech Digital Asset Toolkit',
            tit2: 'Secure and convinient digital asset tool',
            down: '',
            ewm: 'Scan code for download',
            hwtool: '',
        },
        part2: {
            tit: 'Tool Features',
            title1: 'Security',
            text1: 'Local storage of key, more secure with transaction offline signature',
            title2: 'Easy to use',
            text2: 'Easy to use, easy transfer and trade for digital assets',
            title3: 'Fast',
            text3: 'Asset transfer is fast, it only takes 3-5 seconds to the account',
        }
    },

    common: {
        footer1: 'Copyright © 2015~2020 HWelltech  ',
        footer2: 'All Rights Reserved',
        loadMore: 'Load More',
        // download: '下载',
        // timeOut: '请求超时,请重试',
    },
    /*******以下手机端内容******/
    m_menu: {
        home: 'Home',
        service: 'Product & Service ',
        product: 'Products',
        products: 'Tool Kit',
        solution: ' Solutions',
        news: 'News',
        developers: 'Developer',
        browser: 'Explorer',
        aboutus: 'About Us',
        lang_cn: '中',
        lang_en: 'EN'
    },
    m_home: {
        banner: {
            tit1: 'HWelltech',
            desc1: 'Focus on blockchain technology research, development and product innovation',
            tit2: 'HWelltech',
            desc2: 'Provide comprehensive blockchain solution',
            tit3: 'HWChain',
            desc3: 'Provide efficient and stable underlying blockchain platform for different applications',
        },
        part2: {
            tit1: 'HWChain',
            desc1: 'HWChain provides professional and rich blockchain functions',
            tit2: 'Asset Digitization',
            desc2: 'Support the issuance of NFToken to digitize different types of assets.',
            tit3: 'Data To Blockchain',
            desc3: 'Support text and file storage on HWChain.',
            tit4: 'Smart Contract',
            desc4: 'It is easy for contract writing,deployment and execution.',
            tit5: 'Cross-chain Service',
            desc5: 'Realize the interchange between HWChain and other blockchains.',
        },
        part3: {
            tit1: 'Service Content',
            desc1: 'Provide a full range of services from solution consulting to application building',
            tit2: 'Solutions',
            desc2: 'Provide enterprises with a complete set of industry solutions from solution consulting to application construction.',
            tit3: 'Blockchain Service',
            desc3: 'Provide low-threshold, low-cost blockchain services for users with up-chain requirements.',
            tit4: 'Developer Support',
            desc4: 'Provide developers with infrastructure and documentation support to develop blockchain applications.',
        },
        part4: {
            tit1: 'Solutions',
            desc1: 'We have rich experience in realizing applications for various industry blockchains',
            tit2: 'Supply Chain Finance',
            desc2: "Serve supply chain finance by blcokchain's qualities of transparent,non-tamperable and circulation.",
            btn: 'View Solution',
            tit3: 'Tracing',
            desc3: 'To realize counterfeiting traceability by blockchain qualities of transparent,traceability and non-tamperable.',
            tit4: 'Internet Of Things',
            desc4: 'Realize the data up-chain of IoT devices by using the qualities of HWChain height-concurrency and file- uplink.',
            tit5: 'Medical',
            desc5: 'Help medical industry blockchain application by  HWChain with qualities of high concurrency, fast confirmation, and good stability.',
        },
        part5: {
            tit1: 'Partner'
        }
    },
    m_service: {
        part1: {
            tit: 'HWChain',
            desc: 'Self-developed advanced controllable blockchain platform'
        },
        part2: {
            tit1: 'Technical Features',
            desc1: 'Blockchain platform with superior performance',
            tit2: 'High Performance',
            desc2: 'The performance of the HCP consensus reaches 5000+TPS.',
            tit3: 'Safety',
            desc3: 'Multiple security mechanisms ensure asset and txn security.',
            tit4: 'Stable',
            desc4: 'The monitoring system ensure the stability of HWChain service.',
            tit5: 'Scalable',
            desc5: 'Functions such as encryption algorithm can be modularized.',
        },
        part3: {
            tit1: 'Core Underlying Platform',
            desc1: 'Self-developed advanced controllable blockchain bottom platform',
            tit2: 'Consensus Mechanism',
            desc2: 'Self-developed HCP censensus algorithms on base of PBFT, it turns out with high performance.',
            tit3: 'Encryption Algorithm',
            desc3: 'Support international standard / national secret SM2 standard elliptic curve encryption algorithm.',
            tit4: 'Smart Contract',
            desc4: 'LUA virtual machine is efficient and easy to use, its contract execution log can be traced.',
            tit5: 'Data load To Blockchain',
            desc5: 'According to the size of the data, there are two data-winding schemes for text and IPFS.',
            tit6: 'Asset Digitization',
            desc6: 'To realize NFToken non-homogeneous digital assets by ERC721 standard.',
            tit7: 'Bulk Transfer',
            desc7: 'Supports atomic-level single-account bulk transfer.',
            tit8: 'Decentralized Transaction',
            desc8: 'Support the decentralized matching transaction among assets on HWChain.',
            tit9: 'Cross-chain Service',
            desc9: 'Realize the efficient exchange among HWChain and other blockchains.',
        },
        part4: {
            tit1: 'Empower Service Platform',
            desc1: 'Provide easy access to comprehensive blockchain service platform',
            tit2: 'API',
            desc2: 'Rich API can easily interface with various application systems and then offer blockchain basic services.',
            tit3: 'Asset Digital Platform',
            desc3: 'Conveniently distribute Token and NFToken for applications with asset digital requirements.',
            tit4: 'Blockchain Explorer',
            desc4: 'The HWChain account information inquiry tool provides a platform for transaction verification for applications on the HWChain.',
            tit5: 'Operation & Maintenance Platform',
            desc5: 'Real-time monitoring of operation status of HWChain node, ensures HWChain provides stable service.',
        },
        part5: {
            tit1: 'Node Running Status',
            tit2: 'Service online time',
            btn: 'Running Status',
            lb1: 'Service running',
            lb2: 'Nodes',
            lb3: 'Block height',
            lb4: 'Total txAmount',
            days: 'days'
        }
    },
    m_solution: {
        hard: {
            tit: 'Blockchain Solution Provider',
            desc: 'Provide solution consulting to application and build a complete set of industry solutions'
        },
        center: {
            show1: 'Asset Digitalization',
            show2: 'Tracing',
            show3: 'Data Sharing',
            show4: 'Entrusted Certificates',
            tit1: 'Solution',
            tit2: 'Application Case',
            partner: 'Partner',
            time: 'Launch Time',
            tit3: 'Production Information',
            tit4: 'Production Interface',
        },
        part1: {
            text1: 'Assets being digitized can be traded in split,reducing the threshold and complexity of asset trading,  improving assets liquidity and trading efficiency.The process of asset trading is also the process of asset circulating and certifying records in the chain. Open, transparent circulation records and trustable certificate  records in chain can effectively avoid manipulation and cheat in trading process.',
            label: 'IoT Expo Bridge',
            partner: 'World IoT Expo of 2018',
            time: 'Sept.2018',
            text2: 'Developed for 2018 World IoT Expo, IoT Expo Bridge is a tailor-made program recording the interaction between exhibitors and visitors, and delivering added value by blockchain technology. The program facilitates the business card exchange, gift redeem and conference promotion. With the blockchain, exhibitors can obtain the business card information of visitors and issue gifts in an open and transparent way. Visitors get bonus points and redeem gifts by exchanging business cards. The interaction between exhibitors and visitors is completely transparent, which avoids prize manipulation.',
        },
        part2: {
            text1: 'Based on non-tampered and traceable features of blockchain, commodities information are recorded on chain from raw materials to finished products, from production to distribution. One item with one code, facilitizes the visible traceability of the whole chain and the source of the problem commodities, so as to realizes the accountability with evidence. In combination with the IoT, information can also be automatically recorded on chain, realizes less energy consuming and more credibility.',
            label: 'Agricultural Products Traceability',
            partner: 'ChengXin Blockchain Technology (Yunnan) Co., Ltd',
            time: 'June,2019',
            text2: 'ChengXin Agricultural Poducts Traceability Platform  aiming to establish a high-quality system to empower local high-quality agricultural product brands. With features of block chain technology(transparent and anti-tamper), and IoT technology, this platform records cultivation and breeding  information, such as seedling fertilizer, environmental monitoring, production diary, picking and selection, packaging and logistics, sale channels, origin tracing, etc.on chain , so as to improve the credibility of enterprise and products, reduce the cost and difficulty of supervision.',
        },
        part3: {
            text1: 'By blockchain features of traceability and anti-tamper, the data access authorization on chain can be realized, which can effectively solve the problems of data ownership, data sharing control, data anti-tamper and data supervision in the process of data sharing cross multiple agencies and departments. Building of blockchain trusted data exchange greatly improves the efficiency of data security and the data exchange.',
            label: 'Government Data Sharing Platform',
            partner: 'Science and Information Bureau of Wuxi Xinwu District',
            time: 'Nov.2017',
            text2: 'The independent data management among the government departments in Xinwu District of Wuxi City weaken the service ability of the government departments. Also there are snags across law, supervision, privacy and security for  sharing of government data. Facilitated by blockchain technology to achieve data exchange between departments, each department is not only the provider of data, but also the demander of data. Achieved data access authorization with blockchain, government can effectively realize  identification of data ownership,supervision of data rights, ensurance of data validity and security, thus greatly improve the utilization and value of government data.',
        },
        part4: {
            text1: 'With the features of anti-tamper and multi-concensus, blockchain can be used in the field of digital certificates. The information stored by multi-parties is secure, tamper-proof, permanent and reliable. It can be regarded as direct evidence without the need of third party certification. HENGWEI blockchain integrated with IPFs realizes the file on-chain and expands the types of certificates. The IPFs hash of files is recorded on the HENGWEI-chain and cannot be tampered with.',
            label: 'Big Data Platform of Intelligent Factory',
            partner: 'Shanghai XinZengDing Data Technology Co., Ltd',
            time: 'Aug.2018',
            text2: 'XinZengDing collects independent data by IoT equipment in factory. Based on rich data and artificial intelligence technology, it realizes data calculation, data modeling and  AI industry analysis. With blockchain technology, it stored core data calculation results by multi-party concensus. With visualization technology and tools for multi-dimensional data analysis, drilling, tracing, reasoning and deduction,it realizes comprehensive and real-time display of factory operation and provides accurate and trusted judgement for supervisor and credit agencies.',
        },
    },
    m_newslist: {
        tit: 'News and information',
        desc: 'Get the latest blockchain industry news',
        time: 'Published: ',
        more: 'Load More',
        nomore: 'No More'
    },
    m_aboutus: {
        part1: {
            p1: '持之以',
            p11: '恒',
            p2: '事在人',
            p22: '为',
            p1_en: 'Persevere,human effort can achieve anything',
            p2_en: '',
        },
        part2: {
            tit: 'Company Profile',
            p1: "Jiangsu Hengwell Information Technology Co., Ltd. (hereinafter referred to as Hwelltech ) is an enterprise founded by overseas returned talents, which focuses on the research, development and application of the bottom layer of the blockchain. The company was founded in 2015. Keep with frontier blockchain technology, Hwelltech has its own core and underlying technologies of blockchain and blockchain application subsidiaries, which are planned to cover a complete blockchain ecosystem, including blockchain underlying technology research & development and application services. Hwelltech provides government and corporations with smart city application, public service application, IoT application . Hwelltech's own blockchain intellectual property  and Co-Chain technology is in line with international top level in terms of scalability, TPS, response delay and other technical indicators. Its realization of smart contract and Atomicity Cross-Chain is ahead of domestic competitors. At present, Hwelltech is tackling the most cutting-edge IPFs storage and hierarchical fragmentation in global blockchain research and development, and continues standing the leading position in the technology.",
            p21: 'With the announcement by the State Internet Information Office for the second batch of domestic blockchain service filings, "HWChain" successfully filed with No.',
            p22: '(snxb No. 32021419481366870014)',
            p23: '.',
            p3: "Catering to globalization of blockchain, Hwelltech positioned as an global company with independent R & D technology since its establishment, and it has distributed and expanded industry resources in Canada and Singapore. By the first half of 2019, the company has 5 overseas operating institutions and partners, and  also established strategic cooperation with global Chip IP giant company ARM and Zhangjiang High-Technology Park, Johnson China, Geely Auto, New Hope Group, etc."
        },
        part3: {
            tit: 'Company Honor'
        },
        part4: {
            tit: 'Contact Us',
            p1: '19th Floor, Building D, Cygnus, 111 Linghu Avenue, Xinwu District, Wuxi City',
            p2: '0510-85386599',
            p3: 'Technical Cooperation - service@hwelltech.com',
            p4: 'Business Negotiation - marketing@hwelltech.com',
            p5: 'Strategic Deployment - blockchain@hwelltech.com',
            p6: 'Official Account'
        },
        part6: {
            tit: 'Hwelltech',
            text1: "Relying on Wuxi's strong IoT industry and the successful experience of the world IoT Expo held over years, Hwelltech established a blockchain industry application center in Wuxi. At present, the application of blockchain has  extended to many fields such as IoT, intelligence manufacturing, supply chain management, digital asset trading, etc., which will bring opportunities for new generation of information technology as AI,IoT,cloud computing, big data, mobile Internet, etc., and trigger a new round of technological innovation and industrial upgrade.",
            text2: ' With solid blockchain technology, Hwelltech has accumulated more than 30 overall solutions in nine fields, including medical treatment, agriculture,livelihood, data sharing, fintech etc. Many schemes are the breakthrough innovations in the industry: Cooperating with ARM company to combine blockchain and IoT chips firstly around the world, Its data sharing product of "data governance gateway on blockchain" has become the first domestic blockchain platform applied to public data sharing . "',
        },
        part5: {
            tit: 'Hwelltech Milestones',
            year15: '2015',
            year16: '2016',
            year17: '2017',
            year18: '2018',
            year19: '2019',
            y17: {
                data1: '1/5/2017  ',
                event1: 'The setup of IoT+Blockchain Lab, and the release of Action Plan.',
                data2: '1/8/2017 ',
                event2: 'The release of Bluebook of Innovation Integration of Blockchain and IoT of China.',
                data3: '1/12/2017',
                event3: 'Passed the Blockchain Technology Assessment by China Electronics Standardization Institution.',
                data4: '12/2017 ',
                event4: 'Bluebook of Innovation Integration of Blockchain and IoT is listed in Top 10 most influential events of "2017 Wuxi Software and Information Service Industry (Enterprise)".',
            },
            y18: {
                data1: '1/6/2018',
                event1: 'Initiated the Establishment of China Canada IoT and Blockchain Industry Development Research Institute (Wuxi Branch).',
                data2: '1/8/2018 ',
                event2: 'Officially Establishment of China Canada IoT and Blockchain Industry Development Research Institute (Wuxi Branch).',
                data3: '1/9/2018',
                event3: 'Host the Conference of Block Chain and IoT Integration Development Summit of 2018 World IoT Expo.',
            },
            y19: {
                data1: '1/4/2019',
                event1: 'Preparing for the China First Local Standards for Integration of IoT and Blockchain.',
                data2: '1/8/2019',
                event2: 'Become Member of Board of Directors of China Blockchain Technology and Industry Development Forum.',
                data3: '18/10/2019',
                event3: 'HWChain passed Blockchain Information Services Approval of China',
            }
        }
    },
    m_foot: {
        desc1: 'Copyright © 2015~2020 HWelltech ',
        desc2: ' All Rights Reserved',
    },
    m_hwtool: {
        part1: {
            tit1: 'Hwelltech Digital Asset Toolkit',
            tit2: 'Secure and convinient digital asset tool',
            down: '',

        },
        part2: {
            tit: 'Tool Features',
            title1: 'Security',
            text1: 'Local storage of key, more secure with transaction offline signature',
            title2: 'Easy to use',
            text2: 'Easy to use, easy transfer and trade for digital assets',
            title3: 'Fast',
            text3: 'Asset transfer is fast, it only takes 3-5 seconds to the account',
        }
    },



}

export default en